import { render, staticRenderFns } from "./category-widget.vue?vue&type=template&id=49a904ab&"
import script from "./category-widget.vue?vue&type=script&lang=js&"
export * from "./category-widget.vue?vue&type=script&lang=js&"
import style0 from "./category-widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports